const makeFilterData = (fields) => fields.map(({
  field, value, nullable, includeNull, exclude, range, gte, lte, match,
}) => {
  if (nullable) {
    return {
      bool: {
        must_not: {
          exists: { field },
        },
      },
    };
  }

  // Matches documents having one of the values OR no value at all.
  // An empty value list narrows it down to documents without a value.
  if (includeNull) {
    return {
      bool: {
        should: [
          {
            terms: {
              [field]: Array.isArray(value) ? value : [value],
            },
          },
          {
            bool: {
              must_not: {
                exists: { field },
              },
            },
          },
        ],
        minimum_should_match: 1,
      },
    };
  }

  if (exclude) {
    return {
      bool: {
        must_not: {
          terms: {
            [field]: Array.isArray(value) ? value : [value],
          },
        },
      },
    };
  }

  if (range) {
    return {
      range: {
        [field]: {
          gte,
          lte,
        },
      },
    };
  }

  // Matches documents having one of the values by tokenized (analyzed) data
  // instead of exact match.
  if (match) {
    return {
      bool: {
        should: (Array.isArray(value) ? value : [value]).map((matchValue) => ({
          match: {
            [field]: matchValue,
          },
        })),
        minimum_should_match: 1,
      },
    };
  }

  return {
    terms: {
      [field]: Array.isArray(value) ? value : [value],
    },
  };
});

export default makeFilterData;
